import {
  TRANSACTION_SORT_ENUMS,
  TransactionSortType,
} from "../types/Transaction";

export const STATUS_NAME = {
  canceled: "profile.balance.history.model.result.canceled",
  success: "profile.balance.history.model.result.success",
  pending: "profile.balance.history.model.result.pending",
  request: "profile.balance.history.model.result.pending",
  error: "profile.balance.history.model.result.error",
  rejected: "profile.balance.history.model.result.error",
};

export const TRANSACTION = {
  deposit: { type: "profile.navigation.deposit" },
  withdraw: { type: "profile.navigation.withdraw" },
};

export const TRANSACTION_SORT: TransactionSortType[] = [
  {
    id: TRANSACTION_SORT_ENUMS.ALL,
    title: "transactions.all",
    option: TRANSACTION_SORT_ENUMS.ALL,
  },
  {
    id: TRANSACTION_SORT_ENUMS.PAYMENT,
    title: "transactions.methods",
    option: TRANSACTION_SORT_ENUMS.PAYMENT,
  },
  {
    id: TRANSACTION_SORT_ENUMS.REFERRAL,
    title: "transactions.sort.friend",
    option: TRANSACTION_SORT_ENUMS.REFERRAL,
  },
  {
    id: TRANSACTION_SORT_ENUMS.BONUS,
    title: "transactions.bonuses",
    option: TRANSACTION_SORT_ENUMS.BONUS,
  },
];
